import { render, staticRenderFns } from "./JNJUser.vue?vue&type=template&id=6285bb6f&"
import script from "./JNJUser.vue?vue&type=script&lang=js&"
export * from "./JNJUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports